import api from '../../api';

// initial state
const state = {
    onLoading: true,
    data: [],
    pagination: {
        offset: 0,
        limit: 9999
    }
};

// getters
const getters = {};

// actions
const actions = {
    index({ commit }, payload) {
        let { roleId, query } = payload;
        return api
            .adminRolePermissionIndex(roleId, {
                offset: state.pagination.offset,
                limit: state.pagination.limit,
                ...query
            })
            .then(res => {
                commit('setData', res.data.data);
                commit('setLocalStorage', res.data.data);
                return res;
            });
    }
};

// mutations
const mutations = {
    setData(state, data) {
        state.data = data;
        state.onLoading = false;
    },
    // eslint-disable-next-line
    setLocalStorage(state, data) {
        localStorage.setItem('rpem', JSON.stringify(data));
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
